import React from 'react';
import styled from '@emotion/styled';

import { BulletPoint } from '../../types/types';

import { AccordionHeader } from './AccordionHeader';
import { AccordionDetails } from './AccordionDetails';

import { StyleLibrary } from '@vm/omega-shared-component-webapp';
const { pxToRem } = StyleLibrary;

const AccordionContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: 'transparent',
  border: 'none',
  borderTop: '1px solid var(--color-border)',
  boxShadow: 'none',
  margin: 0,
  '&:before': {
    display: 'none',
  },
  '&:last-child': {
    borderBottom: '1px solid var(--color-border)',
    marginBottom: pxToRem(64),
  },
});

type AccordionProps = {
  expanded: boolean;
  point: BulletPoint;
  onChange: (event: React.ChangeEvent<{}>, isExpanded: boolean) => void;
  index: number;
};

export const Accordion: React.FC<AccordionProps> = props => {
  return (
    <AccordionContainer data-testid='mp-accordion' id={`accordion${props.index}`} aria-controls={`accordion${props.index}-details`}>
      <AccordionHeader expanded={props.expanded} onChange={props.onChange} title={props.point.title} />
      <AccordionDetails id={`accordion${props.index}-details`} description={props.point.description} index={props.index} expanded={props.expanded} />
    </AccordionContainer>
  );
};
